import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomFunctions } from '../../../shared/helpers/custom-functions.helper';
import { Activity } from '../../../shared/models/activity.model';

@Component({
  standalone: false,
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html'
})

export class ActivityLogComponent {
  @Input() activities: Array<Activity>;
  orderId: string;
  isListEmpty: boolean;
  subscription: Subscription;

  constructor(public customFunctions: CustomFunctions) {}

  trackByFn(index: number): number {
    return index;
  }
}